import styled from 'styled-components';

export const Text1 = styled.div`
  font-size: 16px;
  color: black;
  margin: 40px 0 10px 20px;
`;

export const Text2 = styled.div`
  font-size: 24px;
  color: #00ae80;
  font-weight: bold;
  margin: 15px 0 5px 20px;
`;

export const Text3 = styled.div`
  font-size: 16px;
  color: #00ae80;
  margin: 0 0 10px 20px;
`;
